<div class="et-paper-author-search-container flex flex-column mt-5 mx-4 justify-content-between">
  <div>
    <span i18n>Search authors by email, ORCID iD or name:</span>

    <div class="mt-3">
      <et-search-member [members]="filteredAuthors$ | async"
                        (filter)="filterAuthors($event)"
                        (selectItem)="onSelect($event)"
                        emptyMessage="No authors found"
                        i18n-emptyMessage>
      </et-search-member>
    </div>

    @if (selectedAuthors?.length) {
      <div class="grid grid-nogutter justify-content-between mt-3">
        @for (selectedAuthor of selectedAuthors; track trackByFunc($index, selectedAuthor)) {
          <div @animateDisplay
               class="col-6 flex flex-column et-paper-author-search-dialog-selected-container mb-3">
            <div class="et-paper-author-search-dialog-selected-header flex">
              <span class="align-self-center ml-3">
                {{ selectedAuthor.firstName }} {{ selectedAuthor.lastName }}
              </span>
              <i class="fas fa-trash ml-auto align-self-center cursor-pointer mr-3"
                 (click)="onUnselect(selectedAuthor)"
                 tooltipPosition="top"
                 pTooltip="Click to remove author"
                 i18n-pTooltip>
              </i>
            </div>
            @if (selectedAuthor.email; as email) {
              <div class="flex flex-column m-3">
                <span class="font-bold mb-1"
                      i18n> {{ selectedAuthor.authorEmails?.length ? 'Emails' : 'Email'}} </span>
                <span>{{ email }}</span>
                @for (authorEmail of selectedAuthor.authorEmails; track authorEmail; let isFirst = $first) {
                  <div class="flex flex-row">
                    <span class="et-author-email mt-1">
                      {{ authorEmail }}
                    </span>
                    @if (isFirst) {
                      <i class="sc-grey1 cursor-pointer fas fa-info-circle ml-1 align-self-center"
                         pTooltip="Email address indicated as author's email address in one or several previously submitted paper(s)"
                         i18n-pTooltip></i>
                    }
                  </div>
                }
              </div>
              <p-divider class="et-divider-horizontal"></p-divider>
            }
            @if (selectedAuthor.universityOrOrganization; as universityOrOrganization) {
              <div class="flex flex-column m-3">
                <span class="font-bold mb-1"
                      i18n>University/Organization</span>
                <span>{{ universityOrOrganization }}</span>
              </div>
              <p-divider class="et-divider-horizontal"></p-divider>
            }
            @if (selectedAuthor.orcidId; as orcidId) {
              <div class="flex flex-column m-3">
                <span class="font-bold mb-1"
                      i18n>ORCID iD</span>
                <span>{{ orcidId }}</span>
              </div>
              <p-divider class="et-divider-horizontal"></p-divider>
            }
            @if (selectedAuthor.countryName; as countryName) {
              <div class="flex flex-column m-3">
                <span class="font-bold mb-1"
                      i18n>Country</span>
                <span>{{ countryName }}</span>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  @if (!selectedAuthors?.length) {
    <div class="flex flex-column align-items-center">
      <i class="sc-rounded-outlined-icon-2 sc-grey fas fa-search"></i>
      <span class="mt-4"
            i18n>No authors found yet</span>
    </div>
  }

  <p-button scSubmitButton
            [requestInProcess]="requestInProcess"
            [disabled]="saveDisabled"
            (onClick)="save()"
            class="flex justify-content-center mt-3"
            label="Save"
            i18n-label>
  </p-button>
</div>